/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByTitle } from './Scaffolding';
import {
    TextField,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    DateField,
    Datagrid,
    UrlField,
    SimpleShowLayout,
    ReferenceField,
    ReferenceInput,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { EditToolbar } from '../layout/EditToolbar';
import { AutocompleteInput, BooleanInput, DateInput, TextInput } from '../lib/wrappers/Inputs';

export const DeliveryInstitutionLabels = {
    pageTitle: 'Delivery Institutions',
    Title: 'Name',
    institutioncode: 'Institution Code',
    phonenumber: 'Phone Number',
    faxnumber: 'Fax Number',
    institutionstatus_id: 'Institution Status',
    partnerriskmatrix_id: 'Partner Risk Matrix',
    approvalperiodfrom: 'Approval period from',
    approvalperiodto: 'Approval period to',
    approvalstatus_id: 'Approval Status',
    contactemail: 'Contact email',
};

export const DeliveryInstitutionList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={DeliveryInstitutionLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField
                        label={DeliveryInstitutionLabels.Title}
                        source="Title"
                    />
                    <BooleanField source="current" />
                    <UrlField source="url" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const DeliveryInstitutionEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit title={<ShowTitleByTitle />} {...props} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="id" disabled />
                    <TextInput
                        label={DeliveryInstitutionLabels.Title}
                        source="Title"
                    />
                    <TextInput
                        label={DeliveryInstitutionLabels.institutioncode}
                        source="institutioncode"
                    />
                    <TextInput
                        label={DeliveryInstitutionLabels.phonenumber}
                        source="phonenumber"
                    />
                    <TextInput
                        label={DeliveryInstitutionLabels.faxnumber}
                        source="faxnumber"
                    />
                    <TextInput source="email" />
                    <TextInput source="contact_person" />
                    <TextInput source="contact_role" />
                    <BooleanInput source="current" />
                    <TextInput
                        label={DeliveryInstitutionLabels.institutionstatus_id}
                        source="institutionstatus_id"
                    />
                    <TextInput
                        label={DeliveryInstitutionLabels.partnerriskmatrix_id}
                        source="partnerriskmatrix_id"
                    />
                    <DateInput
                        label={DeliveryInstitutionLabels.approvalperiodfrom}
                        source="approvalperiodfrom"
                    />
                    <DateInput
                        label={DeliveryInstitutionLabels.approvalperiodto}
                        source="approvalperiodto"
                    />
                    <TextInput
                        label={DeliveryInstitutionLabels.approvalstatus_id}
                        source="approvalstatus_id"
                    />
                    <TextInput
                        label={DeliveryInstitutionLabels.contactemail}
                        source="contactemail"
                    />
                    <ReferenceInput
                        label="Country"
                        reference="Country"
                        source="country_id"
                    >
                        <AutocompleteInput optionText="Title" />
                    </ReferenceInput>
                    <TextInput source="url" />
                    <TextInput source="created_at" disabled />
                    <TextInput source="updated_at" disabled />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const DeliveryInstitutionCreate = (props) => (
    <Create {...props} redirect="edit">
        <SimpleForm>
            <TextInput label={DeliveryInstitutionLabels.Title} source="Title" />
            <TextInput
                label={DeliveryInstitutionLabels.institutioncode}
                source="institutioncode"
            />
            <TextInput
                label={DeliveryInstitutionLabels.phonenumber}
                source="phonenumber"
            />
            <TextInput
                label={DeliveryInstitutionLabels.faxnumber}
                source="faxnumber"
            />
            <TextInput source="email" />
            <TextInput
                label={DeliveryInstitutionLabels.contact_person}
                source="contact_person"
            />
            <TextInput source="contact_role" />
            <BooleanInput source="current" />
            <TextInput
                label={DeliveryInstitutionLabels.institutionstatus_id}
                source="institutionstatus_id"
            />
            <TextInput
                label={DeliveryInstitutionLabels.partnerriskmatrix_id}
                source="partnerriskmatrix_id"
            />
            <DateInput
                label={DeliveryInstitutionLabels.approvalperiodfrom}
                source="approvalperiodfrom"
            />
            <DateInput
                label={DeliveryInstitutionLabels.approvalperiodto}
                source="approvalperiodto"
            />
            <TextInput
                label={DeliveryInstitutionLabels.approvalstatus_id}
                source="approvalstatus_id"
            />
            <TextInput
                label={DeliveryInstitutionLabels.contactemail}
                source="contactemail"
            />
            <ReferenceInput
                label="Country"
                reference="Country"
                source="country_id"
            >
                <AutocompleteInput optionText="Title" />
            </ReferenceInput>
            <TextInput source="url" />
        </SimpleForm>
    </Create>
);

export const DeliveryInstitutionShow = (props) => (
    <Show title={<ShowTitleByTitle />} {...props}>
        <SimpleShowLayout>
            <TextField label={DeliveryInstitutionLabels.Title} source="Title" />
            <TextField
                label={DeliveryInstitutionLabels.institutioncode}
                source="institutioncode"
            />
            <TextField
                label={DeliveryInstitutionLabels.phonenumber}
                source="phonenumber"
            />
            <TextField
                label={DeliveryInstitutionLabels.faxnumber}
                source="faxnumber"
            />
            <TextField source="email" />
            <TextField source="contact_person" />
            <TextField source="contact_role" />
            <BooleanField source="current" />
            <TextField
                label={DeliveryInstitutionLabels.institutionstatus_id}
                source="institutionstatus_id"
            />
            <TextField
                label={DeliveryInstitutionLabels.partnerriskmatrix_id}
                source="partnerriskmatrix_id"
            />
            <DateField
                label={DeliveryInstitutionLabels.approvalperiodfrom}
                source="approvalperiodfrom"
            />
            <DateField
                label={DeliveryInstitutionLabels.approvalperiodto}
                source="approvalperiodto"
            />
            <TextField
                label={DeliveryInstitutionLabels.approvalstatus_id}
                source="approvalstatus_id"
            />
            <TextField
                label={DeliveryInstitutionLabels.contactemail}
                source="contactemail"
            />
            <ReferenceField
                label="Country"
                reference="Country"
                source="country_id"
            >
                <TextField source="Title" />
            </ReferenceField>
            <TextField source="url" />
            <TextField source="created_at" />
            <TextField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
